import { render, staticRenderFns } from "./event-bottom.vue?vue&type=template&id=e8c8d45e&scoped=true&"
import script from "./event-bottom.vue?vue&type=script&lang=js&"
export * from "./event-bottom.vue?vue&type=script&lang=js&"
import style0 from "./event-bottom.vue?vue&type=style&index=0&id=e8c8d45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c8d45e",
  null
  
)

export default component.exports